"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInvoiceShiftDto = instanceOfInvoiceShiftDto;
exports.InvoiceShiftDtoFromJSON = InvoiceShiftDtoFromJSON;
exports.InvoiceShiftDtoFromJSONTyped = InvoiceShiftDtoFromJSONTyped;
exports.InvoiceShiftDtoToJSON = InvoiceShiftDtoToJSON;
exports.InvoiceShiftDtoToJSONTyped = InvoiceShiftDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const StipendDto_1 = require("./StipendDto");
const OnCallShiftDto_1 = require("./OnCallShiftDto");
const NurseProfileDto_1 = require("./NurseProfileDto");
const ShiftType_1 = require("./ShiftType");
const FacilityAbbrDto_1 = require("./FacilityAbbrDto");
/**
 * Check if a given object implements the InvoiceShiftDto interface.
 */
function instanceOfInvoiceShiftDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('specialty' in value) || value['specialty'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('payPeriodMinutesWorked' in value) || value['payPeriodMinutesWorked'] === undefined)
        return false;
    if (!('payPeriodOnCallMinutesWorked' in value) || value['payPeriodOnCallMinutesWorked'] === undefined)
        return false;
    if (!('onCallMinutesWorked' in value) || value['onCallMinutesWorked'] === undefined)
        return false;
    if (!('isFirstPayPeriod' in value) || value['isFirstPayPeriod'] === undefined)
        return false;
    if (!('mealBreakMinutes' in value) || value['mealBreakMinutes'] === undefined)
        return false;
    return true;
}
function InvoiceShiftDtoFromJSON(json) {
    return InvoiceShiftDtoFromJSONTyped(json, false);
}
function InvoiceShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'nurseProfile': json['nurseProfile'] == null ? undefined : (0, NurseProfileDto_1.NurseProfileDtoFromJSON)(json['nurseProfile']),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'specialtyCode': json['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'minutesWorked': json['minutesWorked'],
        'submittedTimeAt': json['submittedTimeAt'] == null ? undefined : (new Date(json['submittedTimeAt'])),
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftDto_1.OnCallShiftDtoFromJSON)(json['onCallShift']),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'facility': (0, FacilityAbbrDto_1.FacilityAbbrDtoFromJSON)(json['facility']),
        'payPeriodMinutesWorked': json['payPeriodMinutesWorked'],
        'payPeriodOnCallMinutesWorked': json['payPeriodOnCallMinutesWorked'],
        'onCallMinutesWorked': json['onCallMinutesWorked'],
        'isFirstPayPeriod': json['isFirstPayPeriod'],
        'mealBreakMinutes': json['mealBreakMinutes'],
    };
}
function InvoiceShiftDtoToJSON(json) {
    return InvoiceShiftDtoToJSONTyped(json, false);
}
function InvoiceShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'nurseProfile': (0, NurseProfileDto_1.NurseProfileDtoToJSON)(value['nurseProfile']),
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'minutesWorked': value['minutesWorked'],
        'submittedTimeAt': value['submittedTimeAt'] == null ? undefined : (value['submittedTimeAt'].toISOString()),
        'onCallShift': (0, OnCallShiftDto_1.OnCallShiftDtoToJSON)(value['onCallShift']),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'facility': (0, FacilityAbbrDto_1.FacilityAbbrDtoToJSON)(value['facility']),
        'payPeriodMinutesWorked': value['payPeriodMinutesWorked'],
        'payPeriodOnCallMinutesWorked': value['payPeriodOnCallMinutesWorked'],
        'onCallMinutesWorked': value['onCallMinutesWorked'],
        'isFirstPayPeriod': value['isFirstPayPeriod'],
        'mealBreakMinutes': value['mealBreakMinutes'],
    };
}
//# sourceMappingURL=InvoiceShiftDto.js.map